<template>
  <div v-if="$parent.det_mapa.length > 0">
    <div
      class="d-flex flex-wrap align-items-center justify-content-between px-3 pt-2 pb-2"
    >
      <div class="btn-group btn-group-sm" role="group">
        <button
          type="button"
          class="btn"
          :class="form.traza ? 'btn-primary' : 'btn-outline-secondary'"
          @click="toggleTraza()"
        >
          <i class="fas fa-route mr-1"></i>
          Traza
        </button>
        <button
          type="button"
          class="btn btn-success"
          @click="generarListadoExcel()"
          v-if="
            $store.getters.can('cs.revisionServiciosInternos.excelCsTraza')
          "
        >
          <i class="far fa-file-excel mr-1"></i>
          Excel
        </button>
      </div>
      <div class="small text-muted">
        <span class="badge badge-success mr-1">&nbsp;</span>
        <span class="mr-3">Inicio</span>
        <span class="badge badge-info mr-1">&nbsp;</span>
        <span class="mr-3">Recorrido</span>
        <span class="badge badge-secondary mr-1">&nbsp;</span>
        <span class="mr-3">Fin</span>
      </div>
    </div>

    <div class="px-3 pb-3">
      <div class="position-relative">
        <div class="rounded overflow-hidden shadow-sm border">
          <gmap-map
            :center="centerMapa"
            :zoom="zoom"
            :options="mapOptions"
            style="width: 100%; height: 560px"
          >
            <gmap-polyline
              v-for="(seg, i) in segmentosTraza"
              :key="'seg-' + i"
              :path="seg.path"
              :editable="false"
              :options="{
                strokeColor: seg.color,
                strokeOpacity: 0.9,
                strokeWeight: 5,
                geodesic: true,
                clickable: false,
              }"
            />
            <gmap-marker
              :key="'mid-' + (m.id || index)"
              v-for="(m, index) in markersIntermedios"
              :position="m.position"
              :icon="m.iconDisplay"
              :clickable="true"
              :zIndex="20"
              @click="abrirInfoPunto(m, 'mid-' + (m.id || index))"
            >
              <gmap-info-window
                :opened="infoAbierto === 'mid-' + (m.id || index)"
                @closeclick="infoAbierto = null"
              >
                <div class="text-left" style="min-width: 240px; max-width: 280px;">
                  <div
                    class="d-flex align-items-center bg-primary text-white px-3 py-2"
                  >
                    <span
                      class="rounded-circle bg-white text-primary d-inline-flex align-items-center justify-content-center mr-2"
                      style="width: 28px; height: 28px;"
                    >
                      <i class="fas fa-truck"></i>
                    </span>
                    <div>
                      <small class="d-block">Vehículo: </small>
                      <strong>{{ m.ficha.titulo }}</strong>
                    </div>
                  </div>
                  <ul class="list-unstyled mb-0 px-3 py-2 bg-light">
                    <li
                      v-for="fila in m.ficha.filas"
                      :key="fila.label"
                      class="d-flex align-items-start py-2 border-bottom"
                    >
                      <i :class="'fas ' + fila.icon + ' text-primary mt-1 mr-2'"></i>
                      <div>
                        <small class="text-muted d-block">{{ fila.label }}</small>
                        <span class="font-weight-bold small">{{ fila.valor }}</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </gmap-info-window>
            </gmap-marker>
            <gmap-marker
              :key="'ext-' + index"
              v-for="(m, index) in markersExtremos"
              :position="m.position"
              :icon="m.icon"
              :animation="2"
              :clickable="true"
              :zIndex="30"
              @click="abrirInfoPunto(m, 'ext-' + (m.id || index))"
            >
              <gmap-info-window
                :opened="infoAbierto === 'ext-' + (m.id || index)"
                @closeclick="infoAbierto = null"
              >
                <div class="text-left" style="min-width: 240px; max-width: 280px;">
                  <div
                    class="d-flex align-items-center bg-primary text-white px-3 py-2"
                  >
                    <span
                      class="rounded-circle bg-white text-primary d-inline-flex align-items-center justify-content-center mr-2"
                      style="width: 28px; height: 28px;"
                    >
                      <i class="fas fa-truck"></i>
                    </span>
                    <div>
                      <small class="d-block">Vehículo</small>
                      <strong>{{ m.ficha.titulo }}</strong>
                    </div>
                  </div>
                  <ul class="list-unstyled mb-0 px-3 py-2 bg-light">
                    <li
                      v-for="fila in m.ficha.filas"
                      :key="fila.label"
                      class="d-flex align-items-start py-2 border-bottom"
                    >
                      <i :class="'fas ' + fila.icon + ' text-primary mt-1 mr-2'"></i>
                      <div>
                        <small class="text-muted d-block">{{ fila.label }}</small>
                        <span class="font-weight-bold small">{{ fila.valor }}</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </gmap-info-window>
            </gmap-marker>
            <gmap-info-window
              :options="infoOptions"
              :position="infoWindowPos"
              :opened="infoWinOpen"
              @closeclick="infoWinOpen = false"
            >
              <div v-html="infoContent"></div>
            </gmap-info-window>
            <gmap-polygon
              v-for="poligono in poligonos"
              :options="{ fillColor: poligono.color }"
              :key="poligono.id"
              :paths="poligono.path"
              :editable="false"
              :draggable="false"
              @click="
                toggleInfoWindowPoli(poligono, poligono.id, poligono.info)
              "
            />
            <gmap-circle
              v-for="circular in circunferencias"
              :options="{ fillColor: circular.color }"
              :key="circular.id"
              :center="circular.center"
              :radius="circular.radius"
              :info="circular.info"
              @click="
                toggleInfoWindowCir(circular, circular.id, circular.info)
              "
            ></gmap-circle>
          </gmap-map>
        </div>

        <div
          id="traza"
          v-show="form.traza"
          class="position-absolute col-md-4 p-2"
          style="top: 0; left: 0; z-index: 10; width: 300px;"
        >
          <div class="card shadow border-0 mb-0">
            <div
              id="trazaHeader"
              class="card-header bg-primary text-white py-2 d-flex align-items-center justify-content-between"
              style="cursor: move;"
              @click="onTrazaHeaderClick"
            >
              <span class="font-weight-bold">
                <i class="fas fa-route mr-1"></i>
                Administrar Traza
              </span>
            </div>
            <div
              v-show="!trazaCollapsed"
              class="card-body py-3"
              @mousedown.stop
            >
              <label class="small font-weight-bold text-muted mb-1">
                Cantidad
              </label>
              <div class="input-group input-group-sm mb-3">
                <input
                  type="number"
                  class="form-control bg-white"
                  placeholder="Cantidad Puntos"
                  v-model="filter.cantidad"
                />
                <div class="input-group-append">
                  <button
                    type="button"
                    class="btn btn-success"
                    id="atras"
                    :disabled="!markersTraza[1]"
                    @click="backPoint()"
                  >
                    <i class="fas fa-angle-double-left"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-success"
                    id="adelante"
                    :disabled="markersTraza.length > puntosTraza.length"
                    @click="nextPoint()"
                  >
                    <i class="fas fa-angle-double-right"></i>
                  </button>
                </div>
              </div>
              <div class="card card-outline card-primary mb-0">
                <div class="card-header py-2 d-flex align-items-center">
                  <i class="fas fa-truck mr-2"></i>
                  <h3 class="card-title mb-0">
                    {{ fichaPanel.titulo || "Vehículo" }}
                  </h3>
                </div>
                <div v-if="html" class="card-body p-0">
                  <ul class="list-group list-group-flush">
                    <li
                      v-for="fila in fichaPanel.filas"
                      :key="fila.label"
                      class="list-group-item d-flex align-items-start py-2 px-3"
                    >
                      <i :class="'fas ' + fila.icon + ' text-primary mt-1 mr-2'"></i>
                      <div>
                        <small class="text-muted d-block">{{ fila.label }}</small>
                        <span class="small font-weight-bold">{{ fila.valor }}</span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div v-else class="card-body p-2 small text-muted">
                  Avance los puntos para ver el detalle del vehículo.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import "jquery-ui-dist/jquery-ui";
import $ from "jquery";
export default {
  name: "CsServicioMapa",

  data() {
    return {
      infoContent: "",
      filter: {},
      zoom: 8,
      html: null,
      trazaCollapsed: false,
      trazaDragging: false,
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      infoAbierto: null,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      mapOptions: {
        tilt: 0,
        heading: 0,
        zoomControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        gestureHandling: "greedy",
        styles: [
          { featureType: "poi", stylers: [{ visibility: "off" }] },
          { featureType: "transit", stylers: [{ visibility: "simplified" }] },
        ],
      },
      form: {
        geocercas: false,
        traza: false,
      },
      center: {
        lat: parseFloat(this.$parent.servicioInterno.bloque.ciudad.latitud),
        lng: parseFloat(this.$parent.servicioInterno.bloque.ciudad.longitud),
      },
      center2: { lat: 4.651371, lng: -74.071509 },
      markers: [],
      markersTraza: [],
      places: [],
      currentPlace: null,
      locations: {},
      poligonos: [],
      circunferencias: [],
      puntoInicialLat: null,
      puntoInicialLng: null,
      puntoFinalLat: null,
      puntoFinalLng: null,
      infoPuntoFinal: "",
      infoPuntoInicial: "",
      puntofin: null,
      vehiculo_id: null,
      latitud: null,
      longitud: null,
      puntosTraza: [],
      det_servicios: [],
      path: [],
    };
  },

  computed: {
    centerMapa() {
      if (
        Number.isFinite(this.center.lat) &&
        Number.isFinite(this.center.lng)
      ) {
        return this.center;
      }
      return this.center2;
    },
    colorPorIcono() {
      return {
        "/img/spot_green.png": "#28a745",
        "/img/spot_yellow.png": "#ffc107",
        "/img/spot_red.png": "#dc3545",
        "/img/spot_blue.png": "#007bff",
      };
    },
    esTrazaCompleta() {
      if (!this.markersTraza.length) return false;
      const last = this.markersTraza[this.markersTraza.length - 1];
      return last.icon === "/img/icon_punto_g.png";
    },
    markersExtremos() {
      if (!this.markersTraza.length) return [];
      const first = this.markersTraza[0];
      const last = this.markersTraza[this.markersTraza.length - 1];
      let lista = [first];
      if (this.markersTraza.length > 1 && this.esTrazaCompleta) {
        lista = [first, last];
      } else if (this.markersTraza.length === 1) {
        lista = [first];
      }
      return lista.map((m) => this.conFicha(m));
    },
    markersIntermedios() {
      if (this.markersTraza.length < 2) return [];
      const fin = this.esTrazaCompleta
        ? this.markersTraza.length - 1
        : this.markersTraza.length;
      return this.markersTraza.slice(1, fin).map((m, i) =>
        this.conFicha({
          ...m,
          idx: i + 1,
          iconDisplay: this.iconoPuntoGps(
            this.colorPorIcono[m.icon] || "#007bff"
          ),
        })
      );
    },
    fichaPanel() {
      return this.fichaGps(this.html);
    },
    segmentosTraza() {
      const segs = [];
      let actual = null;
      this.markersTraza.forEach((m, i) => {
        if (i === 0) return;
        const color = this.colorPorIcono[m.icon] || "#17a2b8";
        const prev = this.markersTraza[i - 1].position;
        if (!actual || actual.color !== color) {
          actual = { color, path: [prev, m.position] };
          segs.push(actual);
        } else {
          actual.path.push(m.position);
        }
      });
      return segs;
    },
  },

  beforeDestroy() {
    const $el = $("#traza");
    if ($el.length && $el.data("ui-draggable")) {
      $el.draggable("destroy");
    }
  },

  methods: {
    toggleTraza() {
      this.form.traza = !this.form.traza;
      this.showDraggable();
    },

    onTrazaHeaderClick() {
      if (this.trazaDragging) return;
      this.trazaCollapsed = !this.trazaCollapsed;
    },

    iconoPuntoGps(color) {
      return {
        path:
          "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z M12 11.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z",
        fillColor: color,
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 1.6,
        scale: 1.65,
        anchor: { x: 12, y: 22 },
      };
    },

    conFicha(m) {
      return {
        ...m,
        ficha: this.fichaGps(m.info),
      };
    },

    fichaGps(html) {
      const etiquetas = [
        "Vehiculo",
        "Vehículo",
        "Fecha reporte",
        "Fecha de reporte",
        "Posicion",
        "Posición",
        "Velocidad",
        "Transportadora",
        "Distancia Recorrida",
        "Distancia recorrida",
      ];
      let texto = String(html || "")
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/(div|p|h[1-6]|li|tr|strong|b)>/gi, "\n")
        .replace(/<[^>]+>/g, " ")
        .replace(/&nbsp;/gi, " ")
        .replace(/\s+/g, " ")
        .trim();

      etiquetas.forEach((et) => {
        const re = new RegExp("(" + et + "\\s*:)", "gi");
        texto = texto.replace(re, "\n$1");
      });

      const ficha = { titulo: "Punto GPS", filas: [] };
      texto.split("\n").forEach((linea) => {
        const l = linea.trim();
        if (!l) return;
        const idx = l.indexOf(":");
        if (idx === -1) {
          if (ficha.filas.length === 0) ficha.titulo = l;
          return;
        }
        const label = l.slice(0, idx).trim();
        const valor = l.slice(idx + 1).trim();
        const key = label
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
        if (key.includes("vehiculo")) {
          ficha.titulo = valor || label;
          return;
        }
        ficha.filas.push({
          label,
          valor,
          icon: this.iconoCampoGps(key),
        });
      });
      return ficha;
    },

    iconoCampoGps(key) {
      if (key.includes("fecha")) return "fa-clock";
      if (key.includes("posicion")) return "fa-map-marker-alt";
      if (key.includes("velocidad")) return "fa-tachometer-alt";
      if (key.includes("transport")) return "fa-building";
      if (key.includes("distancia")) return "fa-road";
      return "fa-info-circle";
    },

    abrirInfoPunto(marker, idUnico) {
      this.html = marker.info;
      this.center = marker.position;
      this.infoWinOpen = false;
      this.infoAbierto = this.infoAbierto === idUnico ? null : idUnico;
    },

    async showDraggable() {
      this.puntosTraza = [];
      this.markers = [];
      if (this.form.traza) {
        this.trazaCollapsed = false;
        this.markersTraza = [];
        this.html = null;
        this.puntosTraza = this.$parent.det_mapa;
        this.det_servicios = this.$parent.servicioInterno.detalle_servicios;
        await this.trazaTurno();
        this.$nextTick(() => {
          const $el = $("#traza");
          if ($el.data("ui-draggable")) {
            $el.draggable("destroy");
          }
          $el.draggable({
            handle: "#trazaHeader",
            cancel: "input, select, textarea, button, .card-body",
            start: () => {
              this.trazaDragging = true;
            },
            stop: () => {
              this.$nextTick(() => {
                this.trazaDragging = false;
              });
            },
          });
        });
      }
    },

    trazaTurno() {
      if (this.puntosTraza.length > 0) {
        const marker = {
          lat: parseFloat(this.puntosTraza[0].latitud),
          lng: parseFloat(this.puntosTraza[0].longitud),
        };
        this.markersTraza.push({
          id: this.puntosTraza[0].id,
          position: marker,
          icon: "/img/icon_punto_g_ok.png",
          info: this.puntosTraza[0].ventana,
        });
        this.center = marker;
        this.zoom = 10;
      } else {
        this.$parent.$refs.closeModal.click();
        this.$swal({
          customClass: {
            container: "my-swal",
          },
          title: "Tramas no encontradas!",
          text: "No se encontraron tramas para este viaje",
          icon: "warning",
        });
      }
    },

    /* async showGeocercas() {
      if (await this.form.geocercas) {
        this.cargando = true;
        await axios
          .get("/api/tif/mapas/showGeocercas", {
            params: { bloque_id: this.$parent.servicioInterno.bloque_id },
          })
          .then((response) => {
            this.cargando = false;
            this.locations = response.data.gps_fin;
            this.locations.geocerca_poli.forEach((geocerca) => {
              if (geocerca.puntos.length > 0) {
                let puntos = [];
                geocerca.puntos.forEach((punto) => {
                  puntos.unshift({
                    lng: parseFloat(punto.longitud),
                    lat: parseFloat(punto.latitud),
                  });
                });
                this.poligonos.unshift({
                  id: geocerca.id,
                  name: geocerca.desc,
                  path: puntos,
                  info: geocerca.ventana,
                  color: geocerca.color,
                });
              }
            });
            for (var j = 0; j < this.locations.geocerca_cir.length; j++) {
              if (this.locations.geocerca_cir[j]["lat"] !== "") {
                this.circunferencias.unshift({
                  center: {
                    lat: parseFloat(this.locations.geocerca_cir[j]["lat"]),
                    lng: parseFloat(this.locations.geocerca_cir[j]["lon"]),
                  },
                  radius: parseFloat(this.locations.geocerca_cir[j]["radio"]),
                  info: this.locations.geocerca_cir[j]["ventana"],
                  color: this.locations.geocerca_cir[j]["color"],
                });
              }
            }
          })
          .catch(function(error) {
            this.cargando = false;
          });
      } else {
        this.locations = {};
        this.circunferencias = [];
        this.poligonos = [];
      }
    }, */

    generarListadoExcel() {
      let servicio_id = this.$parent.servicio_id;
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/cs/mapas/exportCsTraza",
        data: { servicio_id },
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },

    nextPoint() {
      //let cant_det = this.det_servicios.length;
      let dist =
        parseInt(this.markersTraza.length - 1) + parseInt(this.filter.cantidad);

      for (let i = this.markersTraza.length - 1; i < dist; i++) {
        if (this.markersTraza.length < this.puntosTraza.length) {
          const marker = {
            lat: parseFloat(this.puntosTraza[i].latitud),
            lng: parseFloat(this.puntosTraza[i].longitud),
          };
          const fec = moment(this.puntosTraza[i].fechaReporte).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          let icon = "";
          let tipo_tiempo = "";
          // Filtra los servicios que cumplen con la condición
          const serviciosValidos = this.det_servicios.filter((servicio) => {
            const horaIni = moment(servicio.hora_ini).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            const horaFin = moment(servicio.hora_fin).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            return horaIni <= fec && fec <= horaFin;
          });

          // Verifica si hay algún servicio válido
          if (serviciosValidos.length > 0) {
            // Si hay al menos un servicio válido, usa el primero para obtener el tipo de tiempo
            tipo_tiempo = serviciosValidos[0].tipo_tiempo;
          }
          switch (tipo_tiempo) {
            case 1:
              icon = "/img/spot_green.png";
              break;
            case 2:
              icon = "/img/spot_yellow.png";
              break;
            case 3:
              icon = "/img/spot_red.png";
              break;

            default:
              icon = "/img/spot_blue.png";
              break;
          }
          //});

          this.markersTraza.push({
            id: this.puntosTraza[i].id,
            position: marker,
            info: this.puntosTraza[i].ventana,
            icon: icon,
          });
          this.center = marker;
          this.zoom = 10;
          this.html = this.markersTraza[this.markersTraza.length - 1].info;
        } else {
          const marker = {
            lat: parseFloat(this.puntosTraza[i].latitud),
            lng: parseFloat(this.puntosTraza[i].longitud),
          };
          this.markersTraza.push({
            id: this.puntosTraza[i].id,
            position: marker,
            info: this.puntosTraza[i].ventana,
            icon: "/img/icon_punto_g.png",
          });
          this.$swal({
            customClass: {
              container: "my-swal",
            },
            title: "Fin del recorrido!",
            text: "No se encontraron más tramas para este viaje",
            icon: "info",
          });

          break;
        }
      }
    },

    backPoint() {
      let dist =
        parseInt(this.markersTraza.length - 1) - parseInt(this.filter.cantidad);
      for (let i = this.markersTraza.length - 1; i > dist; i--) {
        this.markersTraza.splice(i, 1);
        this.html = this.markersTraza[this.markersTraza.length - 1].info;
      }
    },

    toggleInfoWindow: function(marker, idx, ventana) {
      this.abrirInfoPunto(
        { position: marker.position, info: ventana },
        "ext-" + idx
      );
    },

    toggleInfoWindowPoli: function(poli, idx, ventana) {
      this.infoWindowPos = poli.path[0];
      this.infoContent = ventana;
      this.center = poli.path[0];

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    toggleInfoWindowCir: function(cir, idx, ventana) {
      this.infoWindowPos = cir.center;
      this.infoContent = ventana;
      this.center = cir.center;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
  },
};
</script>
<style>
.my-swal {
  z-index: 20000 !important;
}
</style>
